export const iconFontAwesomeMaritimePersonSwimming = (
	<i className="fa-solid fa-person-swimming"></i>
);
